/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of syncing emails from Gmail (thread replies + auto-imported matching emails)
 * @export
 * @interface SyncClaimEmailsResponse
 */
export interface SyncClaimEmailsResponse {
    /**
     * Whether the sync completed
     * @type {boolean}
     * @memberof SyncClaimEmailsResponse
     */
    success: boolean;
    /**
     * Total number of new messages imported (thread replies + matching emails)
     * @type {number}
     * @memberof SyncClaimEmailsResponse
     */
    imported: number;
    /**
     * Number of Gmail threads checked for replies
     * @type {number}
     * @memberof SyncClaimEmailsResponse
     */
    threadsChecked: number;
    /**
     * Number of emails found for this claim — whose subject line references the claim number or policy number, or that were sent from the insured (matched by email address or sender display name)
     * @type {number}
     * @memberof SyncClaimEmailsResponse
     */
    matchedEmails: number;
    /**
     * Any errors encountered during sync
     * @type {Array<string>}
     * @memberof SyncClaimEmailsResponse
     */
    errors?: Array<string>;
}

/**
 * Check if a given object implements the SyncClaimEmailsResponse interface.
 */
export function instanceOfSyncClaimEmailsResponse(value: object): value is SyncClaimEmailsResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('imported' in value) || value['imported'] === undefined) return false;
    if (!('threadsChecked' in value) || value['threadsChecked'] === undefined) return false;
    if (!('matchedEmails' in value) || value['matchedEmails'] === undefined) return false;
    return true;
}

export function SyncClaimEmailsResponseFromJSON(json: any): SyncClaimEmailsResponse {
    return SyncClaimEmailsResponseFromJSONTyped(json, false);
}

export function SyncClaimEmailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncClaimEmailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'imported': json['imported'],
        'threadsChecked': json['threadsChecked'],
        'matchedEmails': json['matchedEmails'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SyncClaimEmailsResponseToJSON(json: any): SyncClaimEmailsResponse {
    return SyncClaimEmailsResponseToJSONTyped(json, false);
}

export function SyncClaimEmailsResponseToJSONTyped(value?: SyncClaimEmailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'imported': value['imported'],
        'threadsChecked': value['threadsChecked'],
        'matchedEmails': value['matchedEmails'],
        'errors': value['errors'],
    };
}

